export default __webpack_public_path__ + "static/tabs-grouping-dont-704c563026968c816edd9fafb60b2a80464e32d7c05f235c2129ea7dc3a70369.png";